export const DOCUMENT_OPTION = { AI: "ai", MANUAL: "manual", NONE: "none" };
export const ACTION_OPTION = { REPLACE: "REPLACE", APPEND: "APPEND", CATEGORY_POLICY: "CATEGORY_POLICY" };
